export default function removePanelDataItems() {
  sessionStorage.removeItem("lfcPanelToken");
  sessionStorage.removeItem("lfcPanelSessionId");
  sessionStorage.removeItem("lfcPanelConfigString");
}
